// External referral handler - runs immediately
(function() {
  const referrer = document.referrer;
  const currentDomain = window.location.hostname;
  const hasExternalReferrer = referrer && !referrer.includes(currentDomain);
  
  // Force "all brands" for external traffic
  if (hasExternalReferrer) {
    localStorage.setItem("store-selected", "all brands");
    if (document.documentElement) {
      document.documentElement.dataset.storeSelected = "all brands";
    }
  }
  
  // Default to "all brands" if nothing set
  if (!localStorage.getItem("store-selected")) {
    localStorage.setItem("store-selected", "all brands");
    if (document.documentElement) {
      document.documentElement.dataset.storeSelected = "all brands";
    }
  }
})();

// Utility functions
const isAllBrands = (storeValue) => {
  if (!storeValue) return false;
  const normalized = storeValue.toLowerCase().trim();
  return normalized === 'all brands';
};

const getStoreSentenceCase = () => {
  const rawStore = localStorage.getItem("store-selected");
  if (!rawStore) return "All brands";
  return rawStore.charAt(0).toUpperCase() + rawStore.slice(1);
};

const setCollectionsFilters = () => {
  const store = getStoreSentenceCase();
 document.querySelectorAll('a[href*="/collections/"]:not(.color-swatch)').forEach((aTag) => {
    try {
      const url = new URL(aTag.href);
      if (isAllBrands(store)) {
        url.searchParams.delete("filter.p.vendor");
      } else {
        url.searchParams.set("filter.p.vendor", store);
      }
      aTag.href = url.toString();
    } catch (e) {
      console.warn("Skipping invalid URL:", aTag.href);
    }
  });
};

class StoreSwitcher extends HTMLElement {
  constructor() {
    super();
    this.htmlEL = document.querySelector("html");
    this.inputs = this.querySelectorAll("input");
    this._init();
  }
  
  connectedCallback() {
    this.htmlEL = document.querySelector("html");
    this.inputs = this.querySelectorAll("input");
  }

  _init() {
    const currentStore = (localStorage.getItem("store-selected") || "all brands").toLowerCase();
    
    // Set HTML attribute
    this.htmlEL.dataset.storeSelected = currentStore;
    
    // Check the correct radio button
    this.inputs.forEach((input) => {
      if (input.value.toLowerCase() === currentStore) {
        input.checked = true;
      }
    });
    
    // Add change event listeners
    this.inputs.forEach((input) => {
      input.addEventListener("change", () => {
        if (!input.checked) return;
        
        // Uncheck other inputs
        this.inputs.forEach((otherInput) => {
          if (input.name === otherInput.name && input.id !== otherInput.id) {
            otherInput.removeAttribute("checked");
          }
        });
        
        // Store value as lowercase
        const storeValue = input.value.toLowerCase();
        this.htmlEL.dataset.storeSelected = storeValue;
        localStorage.setItem("store-selected", storeValue);
        
        setCollectionsFilters();
        theme.headerNav.init();
        
        const current = new URL(window.location.href);
        if (/\/(?:collections|products)\//.test(current.pathname)) {
          if (current.pathname.includes("/collections/") && !current.pathname.includes("/products/")) {
            if(isAllBrands(storeValue)) {
              current.searchParams.delete("filter.p.vendor");
            } else {
              current.searchParams.set("filter.p.vendor", getStoreSentenceCase());
            }
            window.location.replace(current.toString());
          } else if (current.pathname.includes("/products/")) {
            if(isAllBrands(storeValue)) {
              current.searchParams.delete("filter.p.vendor");
              window.location.replace(current.toString());
            } else {
              window.location.reload();
            }
          }
        }
      });
    });

    // Default to "all brands" if nothing set
    if (!localStorage.getItem("store-selected")) {
      localStorage.setItem("store-selected", "all brands");
      this.htmlEL.dataset.storeSelected = "all brands";
      theme.headerNav.init();
      
      const current = new URL(window.location.href);
      if (/\/(?:collections|products)\//.test(current.pathname)) {
        window.location.reload();
      }
    }
  }
}

customElements.define("store-switcher", StoreSwitcher);

document.addEventListener("DOMContentLoaded", () => {
  setCollectionsFilters();

  const current = new URL(window.location.href);
  const currentStore = localStorage.getItem("store-selected");
  
  // Handle product pages
  if (current.pathname.includes("/products/")) {
    if (current.searchParams.has("filter.p.vendor") && currentStore && isAllBrands(currentStore)) {
      current.searchParams.delete("filter.p.vendor");
      window.location.replace(current.toString());
      return;
    }
    return;
  }
  
  // Handle collection pages
  if (current.pathname.includes("/collections/") && !current.pathname.includes("/products/")) {
    const existingVendor = current.searchParams.get("filter.p.vendor");
    
    if (currentStore && isAllBrands(currentStore)) {
      if (existingVendor) {
        current.searchParams.delete("filter.p.vendor");
        window.location.replace(current.toString());
        return;
      }
    } else if (currentStore && !existingVendor) {
      const storeSentence = getStoreSentenceCase();
      current.searchParams.set("filter.p.vendor", storeSentence);
      window.location.replace(current.toString());
      return;
    }
  }
});

class StoreSwitchMenus extends HTMLElement {
  constructor() {
    super();
    this.currentStore = document.querySelector("html").dataset.storeSelected || "all brands";
    
    this.initMegaMenuHeight();
    this.initShowingLogic();
    this.initResizeListener();
    this.initStoreChangeListener();
  }

  initStoreChangeListener() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'data-store-selected') {
          const newStore = document.querySelector("html").dataset.storeSelected;
          if (newStore !== this.currentStore) {
            this.currentStore = newStore;
            this.refreshEventListeners();
          }
        }
      });
    });
    
    observer.observe(document.querySelector("html"), {
      attributes: true,
      attributeFilter: ['data-store-selected']
    });
  }

  refreshEventListeners() {
    // Remove old event listeners by cloning nodes
    const oldMenus = this.querySelectorAll(".ssm__menu li:has(.ssm__mega-menu)");
    oldMenus.forEach(li => {
      const clone = li.cloneNode(true);
      li.parentNode.replaceChild(clone, li);
    });
    
    // Reinitialize with new store
    this.initShowingLogic();
    this.initMegaMenuHeight();
  }

  getActiveMenuItems() {
    // Only return menu items from the currently active store
    const activeMenu = this.querySelector(`ul[data-store="${this.currentStore}"]`);
    if (!activeMenu) return [];
    return activeMenu.querySelectorAll("li:has(.ssm__mega-menu)");
  }

initShowingLogic() {
  const header = document.getElementById("SiteHeader");
  if (!header) {
    console.warn("SiteHeader not found");
    return;
  }

  const itemsWithMega = this.getActiveMenuItems();
  if (itemsWithMega.length === 0) {
    console.warn("No active mega menu items found for store:", this.currentStore);
    return;
  }
  
  const hideAllMegas = () => {
    itemsWithMega.forEach((li) => {
      const megaMenu = li.querySelector(".ssm__mega-menu");
      if (megaMenu) {
        megaMenu.classList.remove("visible");
      }
    });
  };

  // Only add listeners to active store's non-mega items
  const activeMenu = this.querySelector(`ul[data-store="${this.currentStore}"]`);
  if (activeMenu) {
    activeMenu.querySelectorAll("li:not(:has(.ssm__mega-menu))").forEach((el) => {
      el.addEventListener("mouseover", () => {
        hideAllMegas();
      });
    });
  }

  header.addEventListener("mouseleave", () => {
    hideAllMegas();
  });

  itemsWithMega.forEach((link) => {
    link.addEventListener("mouseover", () => {
      hideAllMegas();
      this.initMegaMenuHeight();
      const megaMenu = link.querySelector(".ssm__mega-menu");
      if (megaMenu) {
        megaMenu.classList.add("visible");
      }
    });
  });
}

  initResizeListener() {
    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        this.initMegaMenuHeight();
      }, 100);
    });
  }

  initMegaMenuHeight() {
    // Only calculate heights for the active store's mega menus
    const activeMenu = this.querySelector(`ul[data-store="${this.currentStore}"]`);
    if (!activeMenu) return;
    
    const megaMenus = activeMenu.querySelectorAll(".ssm__mega-menu");
    megaMenus.forEach((megaMenu) => {
      const container = megaMenu.querySelector(".ssm__mega-menu-container");
      if (!container) return;
      
      const menusMaxHeight =
        Math.max(
          ...Array.from(
            megaMenu.querySelectorAll(".ssm__mega-menu-container > div")
          ).map((menu) => menu.offsetHeight)
        ) + 30;
      container.style.maxHeight = Math.max(250, menusMaxHeight) + "px";
    });
  }
}
customElements.define("store-switch-menus", StoreSwitchMenus);